export const isSmartPhone = () => {
  if (navigator.userAgent.match(/(Android|iPhone)/) && navigator.userAgent.match(/Mobile/)) {
    return true;
  } else {
    return false;
  }
};
